import React from 'react';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import { ThankYouCard } from '../../molecules/thank-you-card/thank-you-card.molecule';
import { ThankYouHeader } from '../../molecules/thank-you-header/thank-you-header.molecule';
import { ThankYouFooter } from '../../molecules/thank-you-footer/thank-you-footer.molecule';
import { Sell } from '../../../common/types/venda';

type Props = {
  venda: Sell;
};

export const Obrigado: React.FC<Props> = ({ venda }) => {
  return (
    <ThankYouContainer
      padding="2rem"
      margin="0 auto"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f7f9fc',
      }}
    >
      <ThankYouHeader />
      <ThankYouContainer
        padding="2rem 0"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ThankYouCard venda={venda} />
      </ThankYouContainer>
      <ThankYouFooter />
    </ThankYouContainer>
  );
};
